import React from 'react';
import { Icon } from '@chakra-ui/react';
import * as IoIcons from 'react-icons/io';
import * as RiIcons from 'react-icons/ri';
import * as AiIcons from 'react-icons/ai';
import { PiLockersBold } from 'react-icons/pi';
import { LuPlus, LuMinus } from 'react-icons/lu';
import { GiCheckeredFlag } from 'react-icons/gi';
import { FaUsers } from 'react-icons/fa';
import { FaUserShield } from 'react-icons/fa6';
import { CgTally } from "react-icons/cg";

import {
  MdBarChart,
  MdPerson,
  MdPersonSearch,
  MdHome,
  MdLogout,
  MdLocationOn,
  MdSavings,
  MdOutlineSavings,
  MdQuestionAnswer,
  MdOutlineShoppingCart,
  MdSupportAgent,
  MdCategory,
  MdStoreMallDirectory,
} from 'react-icons/md';

import CustomerUsers from 'views/admin/customerUsers';
import AdminUsers from 'views/admin/adminUsers';
import OperationLocation from 'views/admin/operationlocation';
import Client from 'views/admin/client';
import BullionDesk from 'views/admin/bulliondesk';
import BullionConfig from 'views/admin/bullionconfig';
import FAQ from 'views/admin/faq/index';
import VariantCharges from 'views/admin/variantcharges';
import PermissionGroups from 'views/admin/permissionGroups/index';
import PermissionGroup from 'views/admin/permissionGroups/permissionGroup/index';
import AddPermissionGroup from 'views/admin/permissionGroups/components/addPermissionGroup/addPermissionGroupForm';
import Ticket from 'views/admin/serviceTicket/index';
// Auth Imports
// import SignInCentered from "views/auth/signIn";
import SignIn from 'views/auth/signIn/index.jsx';
import Companies from 'views/admin/companies';
import SavingPlans from 'views/admin/savingsPlans';
import Company from 'views/admin/companies/company';
import ResetPassword from 'views/auth/resetPassword';
import SetPassword from 'views/auth/setPassword';
import AddNewCompanyForm from 'views/admin/companies/components/addCompanyForm';
import AddOrEditPanel from 'views/admin/PlanVariant/AddOrEditPanel';
import AddNewStoreForm from 'views/admin/companies/company/components/addStoreForm/addStoreForm';
import SavingPlanVariant from 'views/admin/PlanVariant';
import SavingPlanStore from 'views/admin/savingplanstore';
import AddPanel from 'views/admin/PlanVariant/AddOrEditPanel/addPanel';
import EditPanel from 'views/admin/PlanVariant/AddOrEditPanel/index';
import ViewDetails from 'views/admin/serviceTicket/components/ViewDetail';
import Branch from 'views/admin/companies/company/components/store/store';
import AdminUser from 'views/admin/adminUsers/adminUser/index';
import ViewCustomerDetail from 'views/admin/customerUsers/components/ViewComponents';
import HomePage from 'views/admin/homePage/homePage';
import AboutPage from 'views/admin/homePage/components/aboutPage';
import EditSavingPlan from 'views/admin/savingsPlans/components/EditSavingPlan';
import Orders from 'views/admin/orders';
import Order from 'views/admin/orders/order/order';
import CustomerSavingPlans from 'views/admin/customerSavingPlans/customerSavingPlans';
import CustomerSavingPlan from 'views/admin/customerSavingPlans/customerSavingPlan/customerSavingPlan';
import SavingPlanEnrollmentForm from 'views/admin/customerSavingPlans/components/addModal';
import { Modules } from 'config/constant';
import Locker from 'views/admin/lockers/locker/locker';
import PayOnline from 'views/admin/orders/order/payonline';
import { OrderSummaryPage } from 'views/admin/customerSavingPlans/components/OrderSummary';
import MakerCheckers from 'views/admin/makerCheckers';
import Reports from 'views/admin/reports';
import UserCommunication from 'views/admin/userCommunication';
import MakerChecker from 'views/admin/makerCheckers/makerChecker/makerChecker';
import globalLockers from 'views/admin/globalLockers';
import AboutBullionDesk from 'views/admin/bulliondesk/components/about';
import AddBullionDesk from 'views/admin/bulliondesk/components/addBullionDesk';
import ShowroomCustomerAccess from 'views/admin/showroomCustomerAccess';

const routes = [
  {
    name: 'Main Dashboard',
    layout: '/admin',
    path: '/default',
    icon: (
      <Icon
        as={MdHome}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: HomePage,
  },
  {
    name: 'Client',
    layout: '/admin',
    subNavNumber: '1',
    icon: (
      <Icon
        as={MdPerson}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: 'none',
    iconClosed: <LuPlus />,
    iconOpened: <LuMinus />,
    modules: [
      Modules.Client,
      Modules.ClientConfig,
      Modules.OperationLocation,
      Modules.Company,
      Modules.Branch,
    ],
    subNav: [
      {
        name: 'Client',
        layout: '/admin',
        subNavItem: true,
        icon: (
          <Icon
            as={MdPerson}
            width='20px'
            height='20px'
            color='inherit'
          />
        ),
        path: '/client',
        component: Client,
        modules: [Modules.Client, Modules.ClientConfig],
      },
      {
        name: 'Operation Locations',
        layout: '/admin',
        subNavItem: true,
        icon: (
          <Icon
            as={MdLocationOn}
            width='20px'
            height='20px'
            color='inherit'
          />
        ),
        path: '/operation-location',
        component: OperationLocation,
        modules: [Modules.OperationLocation],
      },
      {
        name: 'Companies',
        layout: '/admin',
        subNavItem: true,
        icon: (
          <Icon
            as={MdBarChart}
            width='20px'
            height='20px'
            color='inherit'
          />
        ),
        path: '/companies',
        component: Companies,
        modules: [Modules.Company, Modules.Branch],
      },
    ],
  },
  {
    name: 'Client',
    layout: '/admin',
    icon: (
      <Icon
        as={MdPerson}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/client',
    component: Client,
    hide: true,
  },
  {
    name: 'Operation Locations',
    layout: '/admin',
    icon: (
      <Icon
        as={MdLocationOn}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/operation-location',
    component: OperationLocation,
    hide: true,
  },
  {
    name: 'About',
    layout: '/admin',
    icon: (
      <Icon
        as={MdPerson}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/about',
    component: AboutPage,
    hide: true,
  },
  {
    name: 'Bullion Desk',
    layout: '/admin',
    icon: (
      <Icon
        as={MdQuestionAnswer}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/bullion-desks',
    component: BullionDesk,
    modules: [Modules.BullionDesk],
  },
  // {
  //   name: 'Bullions',
  //   layout: '/admin',
  //   subNavNumber: '2',
  //   icon: (
  //     <Icon
  //       as={RiIcons.RiCurrencyFill}
  //       width='20px'
  //       height='20px'
  //       color='inherit'
  //     />
  //   ),
  //   path: 'none',
  //   // component: BullionDesk,
  //   iconClosed: <LuPlus />,
  //   iconOpened: <LuMinus />,
  //   modules: [Modules.BullionDesk, Modules.BullionConfig],
  //   subNav: [
  //     {
  //       name: 'Bullion Desk',
  //       layout: '/admin',
  //       subNavItem: true,
  //       icon: (
  //         <Icon
  //           as={RiIcons.RiCurrencyFill}
  //           width='20px'
  //           height='20px'
  //           color='inherit'
  //         />
  //       ),
  //       path: '/bullion-desks',
  //       component: BullionDesk,
  //       modules: [Modules.BullionDesk],
  //     },
  //     // {
  //     //   name: 'Bullion Config',
  //     //   layout: '/admin',
  //     //   subNavItem: true,
  //     //   icon: (
  //     //     <Icon
  //     //       as={IoIcons.IoIosSettings}
  //     //       width='20px'
  //     //       height='20px'
  //     //       color='inherit'
  //     //     />
  //     //   ),
  //     //   path: '/bullion-config',
  //     //   component: BullionConfig,
  //     //   modules: [Modules.BullionConfig],
  //     // },
  //   ],
  // },
  {
    name: 'Bullion Desk',
    layout: '/admin',
    icon: (
      <Icon
        as={MdBarChart}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/bullion-desks',
    component: BullionDesk,
    hide: true,
  },
  {
    name: 'Add Bullion Desk',
    layout: '/admin',
    path: '/addnewbulliondesk',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: AddBullionDesk,
    hide: true,
  },
  {
    name: 'Bullion Desk Detail',
    layout: '/admin',
    path: '/bullion-desk',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: AboutBullionDesk,
    hide: true,
  },
  {
    name: 'Bullion Config',
    layout: '/admin',
    icon: (
      <Icon
        as={MdBarChart}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/bullion-config',
    component: BullionConfig,
    hide: true,
  },
  {
    name: 'Companies',
    layout: '/admin',
    icon: (
      <Icon
        as={MdBarChart}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/companies',
    component: Companies,
    hide: true,
  },
  {
    name: 'Company',
    layout: '/admin',
    path: '/company',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: Company,
    hide: true,
  },
  {
    name: 'Enroll in Saving Plan',
    layout: '/admin',
    path: '/savingplanenroll',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: SavingPlanEnrollmentForm,
    hide: true,
  },
  {
    name: 'Add Company',
    layout: '/admin',
    path: '/addnewcompany',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: AddNewCompanyForm,
    hide: true,
  },
  {
    name: 'Branch',
    layout: '/admin',
    path: '/store',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: Branch,
    hide: true,
  },
  {
    name: 'Add Variant',
    layout: '/admin',
    path: '/addvariant',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: AddPanel,
    hide: true,
  },
  {
    name: 'Edit Variant',
    layout: '/admin',
    path: '/editvariant',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: EditPanel,
    hide: true,
  },
  {
    name: 'AddNewStoreForm',
    layout: '/admin',
    path: '/addnewstore',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: AddNewStoreForm,
    hide: true,
  },
  {
    name: 'View Ticket Details',
    layout: '/admin',
    path: '/ticketDetails',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: ViewDetails,
    hide: true,
  },
  {
    name: 'Savings',
    layout: '/admin',
    subNavNumber: '3',
    icon: (
      <Icon
        as={MdSavings}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: 'none',
    iconClosed: <LuPlus />,
    iconOpened: <LuMinus />,
    modules: [
      Modules.SavingPlan,
      Modules.SavingPlanVariant,
      Modules.SavingPlanStore,
    ],
    subNav: [
      {
        name: 'Saving Plans',
        layout: '/admin',
        icon: (
          <Icon
            as={MdSavings}
            width='20px'
            height='20px'
            color='inherit'
          />
        ),
        path: '/savingsplans',
        component: SavingPlans,
        modules: [Modules.SavingPlan],
      },
      {
        name: 'Saving Plan Variants',
        layout: '/admin',
        path: '/savingsplanvariant',
        icon: (
          <Icon
            as={MdCategory}
            width='16px'
            height='16px'
            color='inherit'
          />
        ),
        component: SavingPlanVariant,
        modules: [Modules.SavingPlanVariant],
      },
      {
        name: 'Saving Plan Branches',
        layout: '/admin',
        path: '/variantstores',
        icon: (
          <Icon
            as={MdStoreMallDirectory}
            width='16px'
            height='16px'
            color='inherit'
          />
        ),
        component: SavingPlanStore,
        modules: [Modules.SavingPlanStore],
      },
      // {
      //   name: 'Saving Plan Variant Charges',
      //   layout: '/admin',
      //   path: '/variantcharges',
      //   icon: (
      //     <Icon
      //       as={MdCurrencyRupee}
      //       width='16px'
      //       height='16px'
      //       color='inherit'
      //     />
      //   ),
      //   component: VariantCharges,
      //   modules: ['Saving Plan Branch'],
      // },
    ],
  },
  {
    name: 'Saving Plans',
    layout: '/admin',
    icon: (
      <Icon
        as={MdSavings}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/savingsplans',
    component: SavingPlans,
    hide: true,
  },
  // {
  //   name: 'Variant Charges',
  //   layout: '/admin',
  //   icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
  //   path: '/variantcharges',
  //   component: VariantCharges,
  //   hide: true,
  // },
  {
    name: 'Saving Plan',
    layout: '/admin',
    icon: (
      <Icon
        as={MdSavings}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/savingplan',
    component: EditSavingPlan,
    hide: true,
  },
  {
    name: 'Saving Plan Variant',
    layout: '/admin',
    path: '/savingsplanvariant',
    icon: (
      <Icon
        as={MdOutlineSavings}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: SavingPlanVariant,
    hide: true,
  },
  {
    name: 'Saving Plan Branches',
    layout: '/admin',
    path: '/variantstores',
    icon: (
      <Icon
        as={MdOutlineSavings}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: SavingPlanStore,
    hide: true,
  },
  {
    name: 'FAQ',
    layout: '/admin',
    icon: (
      <Icon
        as={MdQuestionAnswer}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/faq',
    component: FAQ,
    modules: [Modules.Faq],
  },

  {
    name: 'Customers',
    layout: '/admin',
    icon: (
      <Icon
        as={FaUsers}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/customerusers',
    component: CustomerUsers,
    modules: [Modules.Customer],
  },
  {
    name: 'Showroom Customer Access',
    layout: '/admin',
    icon: (
      <Icon
        as={MdPersonSearch}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/showroom-customer-access',
    component: ShowroomCustomerAccess,
    modules: [Modules.ShowroomCustomerAccess],
  },
  {
    name: 'Customer Details',
    layout: '/admin',
    path: '/customeruser',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: ViewCustomerDetail,
    hide: true,
  },
  {
    name: 'Admin Users',
    layout: '/admin',
    icon: (
      <Icon
        as={FaUserShield}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/adminusers',
    component: AdminUsers,
    modules: [Modules.AdminUser],
  },
  {
    name: 'Admin User',
    layout: '/admin',
    icon: (
      <Icon
        as={FaUserShield}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/adminuser',
    component: AdminUser,
    hide: true,
  },
  {
    name: 'Permission Groups',
    layout: '/admin',
    icon: (
      <Icon
        as={RiIcons.RiCheckDoubleLine}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/permissiongroups',
    component: PermissionGroups,
    modules: [Modules.PermissionGroup],
  },
  {
    name: 'Permission Group',
    layout: '/admin',
    path: '/permissiongroup',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: PermissionGroup,
    hide: true,
  },
  {
    name: 'Add Permission Group',
    layout: '/admin',
    path: '/addpermissiongroup',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: AddPermissionGroup,
    hide: true,
  },
  {
    name: 'Customer Tickets',
    layout: '/admin',
    icon: (
      <Icon
        as={MdSupportAgent}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/ticketlist',
    component: Ticket,
    modules: [Modules.CustomerTicket],
  },
  {
    name: 'User Communications',
    layout: '/admin',
    icon: (
      <Icon
        as={MdQuestionAnswer}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/user-communication',
    component: UserCommunication,
    modules: [Modules.CustomerTicket],
  },
  {
    name: 'Customer Orders',
    layout: '/admin',
    icon: (
      <Icon
        as={RiIcons.RiShoppingBag3Fill}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/orders',
    component: Orders,
    modules: [Modules.CustomerOrder],
  },
  {
    name: 'Advance Book',
    layout: '/admin',
    icon: (
      <Icon
        as={AiIcons.AiFillGolden}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/lockertransactions',
    component: globalLockers,
    modules: [Modules.CustomerOrder],
  },
  {
    name: 'Customer Saving Plans',
    layout: '/admin',
    icon: (
      <Icon
        as={RiIcons.RiPlantFill}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/mysavingplans',
    component: CustomerSavingPlans,
    modules: [Modules.CustomerOrder],
  },
  {
    name: 'Maker Checkers',
    layout: '/admin',
    icon: (
      <Icon
        as={GiCheckeredFlag}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/makercheckers',
    component: MakerCheckers,
    modules: [Modules.MakerCheckers],
  },
  {
    name: 'Reports',
    layout: '/admin',
    icon: (
      <Icon
        as={CgTally}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/reports',
    component: Reports,
    modules: [Modules.CustomerOrder],
  },
  {
    name: 'Order',
    layout: '/admin',
    icon: (
      <Icon
        as={RiIcons.RiShoppingBag3Fill}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/order',
    component: Order,
    modules: [Modules.CustomerOrder],
    hide: true,
  },
  {
    name: 'Maker Checker',
    layout: '/admin',
    icon: (
      <Icon
        as={RiIcons.RiShoppingBag3Fill}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/makerchecker',
    component: MakerChecker,
    modules: [Modules.MakerCheckers],
    hide: true,
  },
  {
    name: 'Pay Online',
    layout: '/admin',
    icon: (
      <Icon
        as={RiIcons.RiShoppingBag3Fill}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/paymentgateway',
    component: PayOnline,
    modules: [Modules.CustomerOrder],
    hide: true,
  },
  {
    name: 'Order Summary',
    layout: '/admin',
    icon: (
      <Icon
        as={RiIcons.RiShoppingBag3Fill}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/ordersummary',
    component: OrderSummaryPage,
    modules: [Modules.CustomerOrder],
    hide: true,
  },
  {
    name: 'My Plan',
    layout: '/admin',
    icon: (
      <Icon
        as={RiIcons.RiPlantFill}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/myplan',
    component: CustomerSavingPlan,
    modules: [Modules.CustomerOrder],
    hide: true,
  },
  {
    name: 'Advance Book',
    layout: '/admin',
    icon: (
      <Icon
        as={PiLockersBold}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    path: '/lockerdetails',
    component: Locker,
    modules: [Modules.CustomerOrder],
    hide: true,
  },
  {
    name: 'Signin',
    layout: '/auth',
    path: '/sign-in',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: SignIn,
    hide: true,
  },
  {
    name: 'ResetPassword',
    layout: '/auth',
    path: '/resetpassword',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: ResetPassword,
    hide: true,
  },
  {
    name: 'SetPassword',
    layout: '/auth',
    path: '/setpassword',
    icon: (
      <Icon
        as={MdHome}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: SetPassword,
    hide: true,
  },
];

export const Logout = [
  {
    name: 'Log Out',
    layout: '/auth',
    path: '/sign-out',
    icon: (
      <Icon
        as={MdLogout}
        width='16px'
        height='16px'
        color='inherit'
      />
    ),
    component: SignIn,
  },
];

export default routes;
